import { useState, useEffect } from "react";
import { HiOutlineViewGridAdd } from "react-icons/hi";
import { FaSyringe } from "react-icons/fa";
import style from "./Ongoing.module.scss";
import Button from "@mui/material/Button";
import { constructOrderDate } from "../../../helper/DateFormatter";
import { useDispatch, useSelector } from "react-redux";
import { TbStatusChange } from "react-icons/tb";
import { DispatchRidersList } from "../../../redux/orders/actions/orders.actions";
import { useNavigate } from "react-router-dom";
import {
  processNotification,
  processComplete,
  processReturn,
} from "../../../redux/new-order/actions/new-orders.actions";
import { TiCancel } from "react-icons/ti";
import "react-confirm-alert/src/react-confirm-alert.css";

const Hospital = ({
  order_id,
  id,
  component,
  name,
  product,
  address,
  city,
  state,
  tym,
  order_by,
  qty,
  title,
  dispatch_name,
  vendor_name,
  payment_type,
  days_out,
  return_status,
  return_id,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectRider, setSelectRider] = useState("");
  // console.log("selectRider", selectRider);

  const navigate = useNavigate();

  const { dispatchRiders } = useSelector((state) => state.orderReducer);
  // console.log("dispatchRiders", dispatchRiders);

  const badgeColor = () => {
    return "#E0EFFD";
  };

  const icons = () => {
    return <FaSyringe size={25} color="#2457C5" />;
  };

  const colors = () => {
    return "#2457C5";
  };

  const dispatcher = useDispatch();

  useEffect(() => {
    dispatcher(DispatchRidersList());
  }, [dispatcher]);

  const notify = (id) => {
    dispatcher(processNotification({ id: id }));
  };

  const returnDispatch = (id, selectRider) => {
    dispatcher(processReturn({ return_id: id, dispatch_id: selectRider }));
  };

  const complete = (return_id) => {
    dispatcher(processComplete({ return_id: return_id }));
  };

  const numericDaysOut = parseInt(days_out?.split(" ")[0]) || 0;
  console.log("numericDaysOut", numericDaysOut);

  return (
    <>
      <div>
        <div className={style.container}>
          <div className={style.innerContainer}>
            <div className={style.content}>
              <div
                className={`${style.icon}`}
                style={{ background: badgeColor() }}
              >
                {icons()}
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>ID</p>
                <p className={style.text}>{id}</p>
              </div>
            </div>

            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>Hospital Name</p>
                <p className={style.text}>{name}</p>
              </div>
            </div>

            <div className={style.content}>
              <div className={style.icon} style={{ background: badgeColor() }}>
                <HiOutlineViewGridAdd size={20} color={colors()} />
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>QUANTITY</p>
                <p className={style.text}>{qty}</p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>DURATION</p>
                <p className={style.text}>{days_out}</p>
              </div>
            </div>

            <div className={`${style.content} ${style.address}`}>
              <div className={style.icon} style={{ background: badgeColor() }}>
                <TbStatusChange size={20} color={colors()} />
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>RETURN STATUS</p>
                <p className={style.text2}>
                  {return_status === null ? "N/A" : return_status}
                </p>
              </div>
            </div>

            {return_status === "Ready" ? (
              <div className={`${style.content} ${style.address}`}>
                {/* <div className={style.icon} style={{ background: badgeColor() }}>
                <TbStatusChange size={25} color={colors()} />
              </div> */}
                <div className="d-flex flex-column">
                  <p className={style.header}>SELECT RIDER</p>
                  <select
                    className={style.select}
                    value={selectRider}
                    onChange={(e) => setSelectRider(e.target.value)}
                  >
                    <option value="">Select</option>
                    {dispatchRiders &&
                      dispatchRiders.map((rider) => (
                        <option
                          key={rider.dispatch_id}
                          value={rider.dispatch_id}
                        >
                          {rider.dispatch_name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            ) : (
              <div className={`${style.content} ${style.address}`}>
                {/* <div className={style.icon} style={{ background: badgeColor() }}>
                <TbStatusChange size={25} color={colors()} />
              </div> */}
                <div className="d-flex flex-column">
                  <p className={style.header}></p>
                  {/* <select
                    className={style.select}
                    value={selectRider}
                    onChange={(e) => setSelectRider(e.target.value)}
                  >
                    <option value="">Select</option>
                    {dispatchRiders &&
                      dispatchRiders.map((rider) => (
                        <option
                          key={rider.dispatch_id}
                          value={rider.dispatch_id}
                        >
                          {rider.dispatch_name}
                        </option>
                      ))}
                  </select> */}
                </div>
              </div>
            )}

            <div className={style.content}>
              <div className="d-flex flex-column align-items-center justify-content-center">
                {return_status === "Ready" ? (
                  <Button
                    className={style.button}
                    style={{
                      border: `2px solid ${badgeColor()}`,
                      color: colors(),
                    }}
                    onClick={() => returnDispatch(return_id, selectRider)}
                    disabled={loading}
                  >
                    Send To Dispatch
                  </Button>
                ) : return_status === "Assigned" ? (
                  <Button
                    className={style.button}
                    style={{
                      border: `2px solid ${badgeColor()}`,
                      color: colors(),
                    }}
                    onClick={() => complete(return_id)}
                    disabled={loading}
                  >
                    Complete
                  </Button>
                ) : return_status === null || numericDaysOut > 10 ? (
                  <Button
                    className={style.button}
                    style={{
                      border: `2px solid ${badgeColor()}`,
                      color: colors(),
                    }}
                    onClick={() => notify(id)}
                    disabled={loading}
                  >
                    Notify Hospital
                  </Button>
                ) : ["Pending", "Not Ready"].includes(return_status) ? "" : (
                  <Button
                    className={style.button}
                    style={{
                      border: `2px solid ${badgeColor()}`,
                      color: colors(),
                    }}
                    onClick={() => complete(return_id)}
                    disabled={loading}
                  >
                    Complete
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hospital;
